import { FlipFlop } from './../../../utils/index.js';
import hasRoleForAtLeastOneProgram from '../../helpers/hasRoleForAtLeastOneProgram.js';
import hasRoleForSelectedProgram from '../../helpers/hasRoleForSelectedProgram.js';

export const requirements = {
  flipFlopRequirements: ['card-inventory-beta'],
  requiredUserPermissions: ['delivery-internal'],
};

export const verifier = () => {
  const hasAccessForAtLeastOneProgram = hasRoleForAtLeastOneProgram('delivery-internal');
  return FlipFlop.get('card-inventory-beta', false) && hasAccessForAtLeastOneProgram;
};

export const programVerifier = () => {
  const hasAccessForSelectedProgram = hasRoleForSelectedProgram('delivery-internal');
  return FlipFlop.get('card-inventory-beta', false) && hasAccessForSelectedProgram;
};
